/* global axios */
import ApiClient from './ApiClient';

export const buildCompanyParams = (page, sortAttr, search, status, plan) => {
  let params = `page=${page}&sort=${sortAttr}`;
  if (search) {
    params = `${params}&q=${search}`;
  }
  if (status) {
    params = `${params}&status=${status}`;
  }
  if (plan) {
    params = `${params}&plan=${plan}`;
  }
  return params;
};

class CompanyAPI extends ApiClient {
  constructor() {
    super('companies', { accountScoped: true });
  }

  get(page = 1, sortAttr = 'name', search = '', status = '', plan = '') {
    const requestURL = `${this.url}?${buildCompanyParams(
      page,
      sortAttr,
      search,
      status,
      plan
    )}`;
    return axios.get(requestURL);
  }

  search(search = '', page = 1, sortAttr = 'name', status = '', plan = '') {
    const requestURL = `${this.url}/search?${buildCompanyParams(
      page,
      sortAttr,
      search,
      status,
      plan
    )}`;
    return axios.get(requestURL);
  }

  filter(filterParams) {
    return axios.get(`${this.url}/filter`, { params: filterParams });
  }

  getMetrics(companyId) {
    return axios.get(`${this.url}/${companyId}/metrics`);
  }

  getConversations(companyId, params = {}) {
    return axios.get(`${this.url}/${companyId}/conversations`, { params });
  }

  bulkImport(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/bulk_import`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  create(companyData) {
    return axios.post(this.url, { company: companyData });
  }

  update(companyId, companyData) {
    return axios.patch(`${this.url}/${companyId}`, { company: companyData });
  }

  delete(companyId) {
    return axios.delete(`${this.url}/${companyId}`);
  }

  show(companyId) {
    return axios.get(`${this.url}/${companyId}`);
  }
}

export default new CompanyAPI();